import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { ValidatedSubmitButton } from 'ui/components/common/validated-submit-button'
import { FormVertical } from 'ui/components/form/FormVertical'
import { FormVerticalLayout } from 'ui/components/form/FormVerticalLayout'
import { FormVerticalReadOnly } from 'ui/components/form/FormVerticalReadOnly'
import { FormVerticalTextInput } from 'ui/components/form/FormVerticalTextInput'
import { IFormData } from 'ui/components/form/IFormData'
import { t } from 'ui/components/i18n/i18n'
import { AlignRight } from 'ui/components/layout/alignRight/AlignRight'
import {
	IProductCatalogForm,
	productCatalogFormMetadata,
} from 'ui/forms/formProductCatalog'
import { validateForm } from 'ui/lib/validation/formValidator'
import { sosProductCatalogEntry } from 'ui/state'

export const UpdateProductCatalogForm: FC = (props: {
	mode: 'add' | 'edit'
	form: IProductCatalogForm
}) => {
	const formData: IFormData<IProductCatalogForm> = {
		form: props.form,
		metadata: productCatalogFormMetadata,
		onUpdateForm: sosProductCatalogEntry.updateBookForm,
		tPrefix: 'page.manageProductCatalogs.bookForm',
	}

	const validationResult = validateForm(formData.form, formData.metadata)

	return (
		<div>
			<FormVertical>
				<FormVerticalLayout>
					{props.mode === 'edit' && (
						<FormVerticalReadOnly formData={formData} field='id' />
					)}

					<FormVerticalTextInput formData={formData} field='name' />
				</FormVerticalLayout>
				<AlignRight>
					<ValidatedSubmitButton
						testId='submit-upsert-book'
						onClick={async () => {
							await sosProductCatalogEntry.updateBook('upsert')
						}}
						isValid={validationResult.isValid}
					>
						{t(`page.manageProductCatalogs.${props.mode}Book`)}
					</ValidatedSubmitButton>
				</AlignRight>
			</FormVertical>
		</div>
	)
}
